'use strict';

var _ = require('lodash');
var ChartFaresController = function ChartFaresController($scope, $q, $timeout, dataProviderService, chartFaresService, commonFaresChartComponentsService, BrushSelectionFilter, dataRetrieverService, dataRetrieverConstantsService, faresPanelService, classIndicesService) {
  $scope.markets = [];
  $scope.legend = commonFaresChartComponentsService.getInitialLegend();
  $scope.data = [];
  $scope.chartModels = [];
  $scope.noRaDataMarkets = [];
  $scope.sizingParams = {};
  $scope.isChartVisible = true;
  $scope.isChartDisplayable = true;
  function setCustomSearchForGivenMarket(selectedMarket) {
    var searchCriteriaWithGivenMarket = faresPanelService.getSearchCriteriaForGivenMarket(selectedMarket);
    var dataRetrieverForFaresMode = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.FARES_SCREEN, dataRetrieverConstantsService.FARES_MODE);
    dataRetrieverForFaresMode.setCustomSearchCriteriaRules($q.when(searchCriteriaWithGivenMarket));
    var dataRetrieverForFaresAverageMode = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.FARES_SCREEN, dataRetrieverConstantsService.FARES_AVERAGE_MODE);
    dataRetrieverForFaresAverageMode.setCustomSearchCriteriaRules($q.when(searchCriteriaWithGivenMarket));
    var dataRetrieverForPrevFaresAverageMode = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.FARES_SCREEN, dataRetrieverConstantsService.FARES_PREV_AVERAGE_MODE);
    dataRetrieverForPrevFaresAverageMode.setCustomSearchCriteriaRules($q.when(searchCriteriaWithGivenMarket));
    var dataRetrieverForFaresMappedMode = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.FARES_SCREEN, dataRetrieverConstantsService.MAPPED_FARES_MODE);
    dataRetrieverForFaresMappedMode.setCustomSearchCriteriaRules($q.when(searchCriteriaWithGivenMarket));
    var dataRetrieverForFaresMappedModeServices = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.FARES_SCREEN, dataRetrieverConstantsService.CONTRIBUTING_SERVICES_MODE);
    dataRetrieverForFaresMappedModeServices.setCustomSearchCriteriaRules($q.when(faresPanelService.filterByLocationCategory(searchCriteriaWithGivenMarket)));
  }
  $scope.getData = function () {
    return $scope.data[$scope.selectedMarket];
  };
  $scope.initSizingParams = function () {
    $scope.sizingParams.chartCount = $scope.chartModels.length;
    $scope.sizingParams.totalClassCount = _.chain($scope.chartModels).map('data').flatten().map('clazz').uniq().size().value();
  };
  $scope.initChartModels = function () {
    var cabinIndexes = classIndicesService.prepareCabinIndices($scope.selectedMarket);
    $scope.marketTagKey = chartFaresService.getMarketTagKey($scope.selectedMarket, $scope.legend);
    $scope.chartModels = _.chain($scope.data[$scope.selectedMarket]).reduce(function (result, data, cabinCode) {
      result.push({
        data: chartFaresService.createDataForChart(data, $scope.legend, $scope.marketTagKey),
        ranges: [[0, data.length]],
        cabinCode: cabinCode
      });
      return result;
    }, []).sortBy(function (item) {
      return cabinIndexes[item.cabinCode];
    }).forEach(function (item, index, array) {
      item.isFirst = index === 0;
      item.isLast = index === array.length - 1;
    }).value();
    $scope.initSizingParams();
  };
  $scope.updateChartModels = function () {
    $scope.marketTagKey = chartFaresService.getMarketTagKey($scope.selectedMarket, $scope.legend);
    _.forEach($scope.chartModels, function (chartModel) {
      var storedData = $scope.data[$scope.selectedMarket][chartModel.cabinCode];
      chartModel.data = chartFaresService.createDataForChart(storedData, $scope.legend, $scope.marketTagKey);
    });
  };
  $scope.reloadChartData = function () {
    dataProviderService.getData().then(function (data) {
      $scope.data = data.groupedData;
      $scope.markets = _.concat(chartFaresService.getMarkets($scope.data), data.noRaDataMarkets);
      $scope.noRaDataMarkets = data.noRaDataMarkets;
      $scope.isChartVisible = true;
      if (!_.isEmpty(data.groupedData)) {
        $scope.isChartDisplayable = true;
        $scope.selectedMarket = $scope.selectedMarket && $scope.getData() ? $scope.selectedMarket : $scope.markets[0];
        $timeout(function () {
          $scope.initChartModels();
        }, 0);
      } else {
        $scope.selectedMarket = $scope.markets[0];
        $scope.chartModels = [];
        $scope.isChartDisplayable = false;
      }
    });
  };
  $scope.changeMarketHandler = function (market) {
    $scope.selectedMarket = market;
    setCustomSearchForGivenMarket($scope.selectedMarket);
    if (_.includes($scope.noRaDataMarkets, market)) {
      $scope.chartModels = [];
      $scope.brushFilterChanged(createEmptyBrushFilter());
    } else {
      $timeout(function () {
        $scope.initChartModels();
      }, 0);
    }
  };
  function createEmptyBrushFilter() {
    return new BrushSelectionFilter('class-usage', []);
  }
  function createBrushFilter(selectedData, months, market) {
    return new BrushSelectionFilter('class-usage', [{
      classes: selectedData,
      months: months,
      market: market
    }]);
  }
  $scope.classSelectionChange = function () {
    var selectedClasses = _.chain($scope.chartModels).map('selectedClasses').flatten().value();
    var selectedMonths = chartFaresService.getSelectedLegend($scope.legend);
    var brushFilter = createBrushFilter(selectedClasses, selectedMonths, $scope.selectedMarket);
    $scope.brushFilterChanged(brushFilter);
  };
  $scope.resetChartsSelection = function () {
    $scope.$broadcast('chart-class-usage:resetBrushSelection');
  };
  $scope.shouldDisplayChartFaresPanel = function () {
    return $scope.isChartDisplayable || $scope.markets.length > 1;
  };
};
ChartFaresController.$inject = ['$scope', '$q', '$timeout', 'ChartFaresDataProviderService', 'ChartFaresService', 'CommonFaresChartComponentsService', 'BrushSelectionFilterFactory', 'DataRetrieverService', 'DataRetrieverConstantsService', 'FaresPanelService', 'ClassIndicesService'];
module.exports = ChartFaresController;